<template>
    <v-app style="background-color: #ececec;">
      <MitLoading :show="loading" :message="loadingMessage" :progressSize="loadingSize" :progressBar="loadingProgressBar"/>
      <div v-if="!siteLoading">
        <MitHeader class="doNotPrint" :userModel="userModel" :userRoles="userRoles" v-on:logout="logout" v-on:login="login" />
        <MitAppMenu class="doNotPrint" v-show="this.$vuetify.breakpoint.smAndDown == false" v-if="userModel" :userModel="userModel" :userRoles="userRoles" v-on:logout="logout" v-on:login="login"/>

        <v-main  :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pt-10':$vuetify.breakpoint.smAndDown==false}">
            <router-view></router-view>
        </v-main>
      </div>
    </v-app>
</template>

<script>
import axios from 'axios';

import MitLoading from './components/MitLoading.vue';
import MitHeader from './components/MitHeader.vue';
import MitMenu from './components/MitMenu.vue';
import MitAppMenu from './components/MitAppMenu.vue';
import MitUserModel from './models/MitUserModel.js';
import MitUserService from './services/MitUserService.js';
import MitRequestInterceptorService from './services/MitRequestInterceptorService.js';
import {MitEventBus} from './main.js';

export default {
  name: 'app',
  components: {
    MitLoading,
    MitHeader,
    MitMenu,
    MitAppMenu
  },
  data: function() {
    return {
      siteLoading:true,
      loading:false,
      loadingProgressBar:false,
      loadingMessage:'Loading...',
      loadingSize:88,
      userModel:null,
      userRoles:MitUserModel.ROLES,
      requestInterceptor:null
    }
  },
  mounted() {
    MitEventBus.$on('mit-pageloadingservice--loading-changed', this.updateLoading);
  },
  created() {
    //create a request interceptor to handle 401 and 403 app wide
    this.requestInterceptor = new MitRequestInterceptorService(MitUserService,this.$router);

    //Ensure the default calls are successful before proceding
    //Might be better to move to main.js with the config
    MitUserService.getUser()
      .then((result) => {
        this.userModel = result;//values from second promise
        this.siteLoading = false;
        this.updateLoading({loading:false});
      })
      .catch((error) => {
        this.siteLoading = false;
        this.updateLoading({loading:false});
      });
  },
  methods: {
    updateLoading(loadingModel) {
      this.loading = loadingModel.loading;
      this.loadingMessage = loadingModel.message;
      this.loadingSize = loadingModel.loadingSize;
      this.loadingProgressBar = loadingModel.loadingProgressBar;
    },
    login() {
      window.location.href = '/auth/provider';
    },
    logout() {
      window.location.href = '/auth/logout';
    }
  }
}
</script>

<style lang="scss">
#v-app {
  font-family: 'Times New Roman', Helvetica, Arial, sans-serif;
}

.mit-loading-page {
  height:100vh;
}
</style>
